<template>
  <div class="talent_portrait">
    <el-container v-if="portrait_navshow_list && portrait_navshow_list.length">
      <el-main>
        <component v-for="(item,index) in portrait_navshow_list" :class="'comp_'+item.id" :is="item.component"
                   :componentData="item.dataObj"
                   @trimArray="trimArray"></component>
      </el-main>
      <el-aside width="150px">
        <comm-aside @goAnchor="goAnchor" :navList="portrait_navshow_list"
                    :asideActive="asideActive"></comm-aside>
      </el-aside>
    </el-container>
    <div :style="{ height: screenHeight + 'px' }" class="noData" v-else>
      <img :src="noDataImgUrl" alt=""><span>暂无数据</span>
    </div>
  </div>
</template>

<script>
import CommAside from "./CommonAside.vue";
import TabFocus from "./tabItem/TabFocus.vue";
import TabProminent from "./tabItem/TabProminent.vue";
import TabApply from "./tabItem/TabApply.vue";
import TabAbility from "./tabItem/TabAbility.vue";
import TabJob from "./tabItem/TabJob.vue";
import TabInformation from "./tabItem/TabInformation.vue";
import TabEducation from "./tabItem/TabEducation.vue";
import TabWork from "./tabItem/TabWork.vue";
import TabProject from "./tabItem/TabProject.vue";
import TabTrain from "./tabItem/TabTrain.vue";
import TabSkill from "./tabItem/TabSkill.vue";
import TabProfessional from "./tabItem/TabProfessional.vue";
import TabAchievement from "./tabItem/TabAchievement.vue";
import TabHobby from "./tabItem/TabHobby.vue";
import TabRelationship from "./tabItem/TabRelationship.vue";
import portrait_nav_list from "../common/portrait_nav.json";

export default {
  components: {
    CommAside,
    TabFocus,
    TabProminent,
    TabApply,
    TabAbility,
    TabJob,
    TabInformation,
    TabEducation,
    TabWork,
    TabProject,
    TabTrain,
    TabSkill,
    TabProfessional,
    TabAchievement,
    TabHobby,
    TabRelationship,
  },
  props: {
    cusParam_portraitData: Object,
  },
  watch: {
    cusParam_portraitData: function (obj) {
      this.portrait_navshow_list = [];
      this.$nextTick(()=>{
        this.goAnchor("prominent");
        this.asideActive = 0;
      })
      if (Object.keys(obj).length === 0) {
        this.portrait_navshow_list = [{
          "name": "简历亮点",
          "id": "prominent",
          "component": "TabProminent",
          "necessary": true
        },
          {
            "name": "简历关注点",
            "id": "focus",
            "component": "TabFocus",
            "necessary": true
          }]
      } else {
        for (let index = 0, len = this.portrait_nav_list.length; index < len; index++) {
          let newNavObj =this.portrait_nav_list[index], navId = this.portrait_nav_list[index].id;
          if (navId === "") continue;
          if (obj.hasOwnProperty(navId) && (newNavObj["necessary"] || this.judgeIsNoData(obj[navId]))) {
            newNavObj.dataObj = obj[navId];
            this.portrait_navshow_list.push(newNavObj)
          }
        }
        console.log(this.portrait_navshow_list);
      }
    },
    screenHeight(val) {
      if (!this.timer) {
        this.screenHeight = val
        this.timer = true
        let that = this
        setTimeout(function () {
          console.log(that.screenHeight)
          that.timer = false
        }, 400)
      }
    }
  },
  data() {
    return {
      screenHeight: document.body.clientHeight,
      asideActive: 0, // 当前激活的导航索引
      portrait_nav_list: [],
      portrait_navshow_list: [],
      noDataImgUrl: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKgAAABhCAMAAAB1chr6AAAAhFBMVEUAAADy9Pn////y9fzy9fny9fry9vv29v/y9fry9frz9vvy8vj////z9vrz9/vy9frz9PTy9frz9vrz9vry9Prz9fvy9vry9fr09vvy9fry9fvy9vvy9fvz9fvz8//x9Pnx9fry9vvv8/f0+f/r6+7y+Pjx9Pnz9vvy9vry9fre4ebq7fLn24UVAAAAKXRSTlMAfARQSFk3HWqMYSYMLj+dFK6llL+D2NBy4rZy8ukVhMjHQC4MJreIwQV8H3oAAAJCSURBVHja7dvdTqtAFIZhZvgp2NIfdeMgbKkWxbrv//52CQK1Ml1ruhJnYtebiDBHT2jynTT1OI7jOO5Msin36IRnr2Zv0D+L0tIIalG6N4LipdahWKl9KFLqABQndQGKkjoBxUjdgCKkjkBhqStQUOoMFJK6AwWkDkEvkNKhH31Gbu9MDGUoQxnKUCehQwxlKEOvBPphGEP75LJ6z8syf08C6TC0LrJyKBcLV6FB9vdLme8kVFb5t5SL0CabKHFvntTDZLFr0Gh76Pmz7dDz1jFovbnX5BjUf2x7e3sc+zyhQ2WQdNtcvUiqU642uqjQhcjLoayoadD0Vtv5eQKh/uk2B7RPfqWNBlX5t4S8RDgPRZKIUNxpI0GTbKLGnLmOEzAKNH6YTJk6Z6L6M1QdGu/HEwq0XeZ+n493OjJ8n0ogokDvNW1qI2iolCqK9q9rfFJDRbEndLLM45Nv9MHHqCjQja6VNIBGN6go0FttqQE0CFFRoCttvsnI46JA77SJbr/nqDeKiwJNwOI1DF2+HFr2DU+nJxRoBe+0mIHQCBcFKhAV4DtN03S3S4eOn3aH+hMKFLPTKoSg89fX+XGaZwo0RjWDBh8XBXqDKgKg66en9aH+2v0/vu+uFGiIKgCgi666XoxNnFGgPi4AKnFRoAGuVkOPAkXsdJt9aITLPhSx0232oeBOd9mHznDZhwI73V/tQ4Gd7u/tQyUu+1AP7mq/uWPoFULLy52l95M1l0Mbjxz9Ry1wZSM9juM4jvsF/Qe1eUljmww3OQAAAABJRU5ErkJggg==",
      isMonitor:true,
      curMainPageScrollTop:0
    }
  },
  mounted() {
    this.portrait_nav_list = portrait_nav_list

    // 监听滚动事件
    window.addEventListener('scroll', this.onScroll, true)

    const that = this
    window.onresize = () => {
      return (() => {
        window.screenHeight = document.body.clientHeight
        that.screenHeight = window.screenHeight
      })
      ()
    }


  },
  destroy() {
    // 必须移除监听器，不然当该vue组件被销毁了，监听器还在就会出错
    window.removeEventListener('scroll', this.onScroll, true)
  },
  methods: {
    judgeIsNoData(obj){
      let isHaveData = false;
      if(obj != null){
        for(let objKey in obj){
          if(obj[objKey] && obj[objKey].length > 0){
            obj[objKey].forEach((item,index) =>{
              if(item !== '[]' && item !== '0'){
                isHaveData = true;
              }
            })
          }
        }
      }
      return isHaveData;
    },
    goAnchor(compId) {
      this.isMonitor = false;
      this.$el.querySelector('.comp_' + compId).scrollIntoView();
      setTimeout(()=>{
        this.isMonitor = true;
      },500)
    },
    // 滚动监听器
    onScroll() {
      if(!this.isMonitor) return;
      // 获取所有锚点元素
      const navContents = document.querySelectorAll('.component')
      // 所有锚点元素的 offsetTop
      const offsetTopArr = []

      navContents.forEach(item => {
        offsetTopArr.push(item.offsetTop)
      })
      // 获取当前文档流的 scrollTop
      const scrollTop = this.$el.querySelector('.el-main').scrollTop
      // const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      // 定义当前点亮的导航下标
      let navIndex = 0
      for (let n = 0; n < offsetTopArr.length; n++) {
        // 如果 scrollTop 大于等于第n个元素的 offsetTop 则说明 n-1 的内容已经完全不可见
        // 那么此时导航索引就应该是n了
        if (scrollTop >= offsetTopArr[n]) {
          navIndex = n
        }
      }
      this.asideActive = navIndex
    },
    trimArray(array, callback) {
      if (array != null) {
        for (var i = 0; i < array.length; i++) {
          //这里为过滤的值
          if (array[i] == " " || array[i] == null || typeof (array[i]) == "undefined" || array[i] == '  ') {
            array.splice(i, 1);
            i = i - 1;
          }
        }
      }
      callback(array);
    }
  },
};
</script>

<style lang="less" scoped>
.talent_portrait {
  padding-top: 10px;
  background: #F5F5F5;
  font-size: 12px;
}

.el-aside {
  display: block;
  position: absolute;
  padding: 0 10px 0 10px;
  right: 0;
  top: 10px;
  bottom: 0;
  background: #F5F5F5;
}

/deep/ .el-main {
  text-align: left;
  position: absolute;
  right: 135px;
  left: 0;
  top: 10px;
  bottom: 0;
  overflow-y: scroll;
  background: #F5F5F5;
  padding: 0 0 10px 0;

  .component {
    background: #FFFFFF;
    padding: 12px 20px;
    margin-bottom: 10px;

    .main-title {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin-bottom: 12px;
      margin-left:-20px;

      .square {
        width: 6px;
        height: 16px;
        background: var(--theme-color);
        margin-right: 14px;
      }

      .title-content {
        display: flex;
        height: 20px;
        align-items: center;
        font-size: 16px;
        color: #212121;
        letter-spacing: 0;
        line-height: 20px;
        font-weight: 600;
      }

    }

    .main-content {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;

      .sub-title {
        display: flex;
        height: 20px;
        font-size: 12px;
        align-items: center;
        font-weight: 600;
        color: #212121;
        margin-top: 8px;
        margin-bottom: 10px;
      }
      .sub {
        display: flex;
        flex-direction: column;

        .sub-content {
          display: flex;

          .el-timeline {
            width: 100%;

            .el-timeline-item {
              position: relative;
              padding-bottom: 1px;

              .el-timeline-item__tail {
                width: 1px;
                background: #E5E5E5;
              }

              // 圆点颜色
              .el-timeline-item__node {
                width: 12px;
                height: 12px;
                background: white;
                border-radius: 50%;
                border-width: 2px;
                border-style: solid;
                border-color: #276FF5;
              }
            }

            .timeAxis {
              .el-timeline-item__node--normal {
                display: none;
              }

            }

            .timeline-content {
              display: flex;
              flex-direction: column;

              .timeline-title {
                font-size: 12px;
                color: #212121;
                letter-spacing: 0;
                line-height: 18px;
                font-weight: 400;
                margin-bottom: 8px;
              }

              .timeline-tag {
                display: flex;
                flex-direction: row;
              }

              .timeline-detail {
                display: flex;
                flex-direction: column;
                padding: 12px 16px 4px 16px;
                background: #f5f5f5;
                .fold_module{
                  margin-bottom: 8px;
                }
                .slotInfos {
                  display: flex;
                  flex-direction: row;
                  font-size: 14px;
                  color: #212121;
                  letter-spacing: 0;
                  line-height: 21px;
                  margin-bottom: 8px;
                  font-weight: 600;

                  .el-divider {
                    width: 1px;
                    height: 8px;
                    background: #212121;
                  }
                }
              }
            }

          }

          .el-table {
            margin-bottom: 20px;
          }
        }
      }

      .sub-row {
        display: flex;
        flex-direction: row;
        margin-top: 4px;
        .sub-title {
          margin: 0 12px 0 0;
          flex-shrink: 0;
        }
      }
    }
  }

}

.noData {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  img {
    width: 220px;
    height: 125px;
  }

  span {
    font-size: 14px;
    color: #666;
  }
}
</style>
